
import moment from 'moment-timezone'
import { SCORE_COLUMNS, cleanParams } from '~/util/brokerage-hr'

export default {
    props: {
        agent: { type: [Number, String], required: true },
        name: { type: String, default: '' },
        filters: { type: Object, required: true },
    },
    data () {
        return { items: [], loading: false, scoreColumns: SCORE_COLUMNS, requestId: 0, deleting: null }
    },
    watch: {
        agent () { this.load() },
        filters: { deep: true, handler () { this.load() } },
    },
    mounted () {
        this.load()
    },
    methods: {
        async load () {
            const id = ++this.requestId
            this.loading = true
            const res = await this.$try('getFeedbackResponses', cleanParams({ ...this.filters, agent: this.agent }))
            if (id !== this.requestId) return
            this.loading = false
            if (!res || res.error) return
            this.items = res.items
        },
        day (value) {
            return moment.tz(value, 'America/New_York').format('MMM D, YYYY')
        },
        // Test-account answers only; the server refuses any other row.
        async confirmDelete (item) {
            if (this.deleting) return
            const ok = await this.$bvModal.msgBoxConfirm(
                'Delete this test-account answer? Its link will take a new answer afterwards.',
                { title: 'Delete this answer?', okTitle: 'Delete', okVariant: 'danger', centered: true },
            )
            if (!ok) return
            this.deleting = item.id
            const res = await this.$try('deleteFeedbackResponse', item.id)
            this.deleting = null
            if (!res || res.error) return
            this.items = this.items.filter(row => row.id !== item.id)
            this.$emit('deleted', item)
        },
    },
}
